module.exports = __webpack_public_path__ + "img/PL.e2afe0f6.svg";